import { render, staticRenderFns } from "./new-year-activity.vue?vue&type=template&id=28da959c&scoped=true&"
import script from "./new-year-activity.vue?vue&type=script&lang=js&"
export * from "./new-year-activity.vue?vue&type=script&lang=js&"
import style0 from "./new-year-activity.vue?vue&type=style&index=0&id=28da959c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28da959c",
  null
  
)

export default component.exports